import { render, staticRenderFns } from "./OtherUserGroupRegister.vue?vue&type=template&id=7074d4cc&scoped=true&lang=pug"
import script from "./OtherUserGroupRegister.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupRegister.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupRegister.vue?vue&type=style&index=0&id=7074d4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074d4cc",
  null
  
)

export default component.exports